export default __webpack_public_path__ + "static/media/promo_04.fec2fad8.jpg";